import React, {useCallback, useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input"
import Box from "@material-ui/core/Box";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
  useApolloClient,
  useQuery,
} from "/lib/component/util";
import gql from "/vendor/graphql-tag";
import axios from 'axios';
import useRouter from "../util/useRouter";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const openQuery = gql`
  query SwitcherIsOpenQuery {
    modalStack @client
  }
`;

const closeQuery = gql`
  mutation CloseSwitcher {
    clearModal(modal: CREATE_INCIDENT_MODAL) @client
  }
`;

const WINDOW_ID_EVENT_QUERY = gql`
  query FetchWindowIDLog($check: String!, $namespace: String!, $entity: String!) {
    event(check: $check, namespace: $namespace, entity: $entity) {
      id
      check {
        name
        output
      }
    }
  }
`;

export default function CreateIncidentDialog() {
  const router = useRouter();
  const pathname = router.location.pathname
  const variables = pathname.split('/').slice(2)
  const namespace = variables[0] ? `LOC: ${variables[0]} | ` : ''
  const machine = variables[2] ? `ID: ${variables[2]} | ` : ''
  const check = variables[3] ? `Check: ${variables[3]}` : ''
  const isProd = window.location.hostname === "onewatch.betmakers.com"
  const url = isProd ? "https://api.onewatch.hardware-inno.gcpprodau.tbm.sh/incident" : "https://api.onewatch.hardware-inno.gcpprodau.tbm.sh/devincident";
  const client = useApolloClient();

  const { data, loading } = useQuery({query: WINDOW_ID_EVENT_QUERY,
    variables: {
      check: "window-id-log",
      namespace: variables?.[0] || "",
      entity: variables?.[2] || "0"
    },
    fetchPolicy: "network-only",
    skip: !variables[0] || !variables[2],
  });

  const match = data?.event?.check?.output?.match(/:\s+(\d+)/);
  const windowID = `WindowID: ${match && match[1]} | `;

  const email = localStorage.getItem('googleUser') || ''
  const [incident, setIncident] = useState({
    description: '',
    shortDescription: `${namespace} ${machine} ${windowID} ${check}}`,
    urgency: '',
    impact: '',
    category: '',
    caller_id: '',
    email: email
  });

  const [assignToMe, setAssignToMe] = useState(true);

  useEffect(() => {
    setIncident(prevIncident => ({
      ...prevIncident,
      shortDescription: `${namespace} ${machine} ${windowID} ${check}`,
      email: email
    }));
}, [check, machine, namespace, windowID, email, loading]);

  const queryResult = useQuery({ query: openQuery });
  const open = queryResult.data.modalStack.includes("CREATE_INCIDENT_MODAL");

  const handleClose = useCallback(() => {
    client.mutate({ mutation: closeQuery });
  }, [client]);

  const handleInputChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name) {
      setIncident({...incident, [name]: value});
    }
  };

  const handleCheckboxChange = (event: any) => {
    setAssignToMe(event.target.checked);
  };
  const handleCreate = () => {
    const data = {
      caller_id: 'Onewatch - Field Service',
      category: 'Hardware',
      assignment_group: '71bc34a187add510156cab0a0cbb35a0',
      u_short_description: incident.shortDescription,
      u_description: incident.description,
      urgency: incident.urgency,
      impact: incident.impact,
      u_email: email,
      u_serial_number: variables?.[2],
      u_assign_to_caller: assignToMe,
    };
    const headers = isProd ? {
      'Content-Type': 'application/json',
      'Authorization': `Basic ${Buffer.from('Integrationuser:.>4#wnT=(Y=hsMObyX>ojh*q__6cEk:M8N!oF?32').toString('base64')}`,
    } : {
      'Content-Type': 'application/json',
      'Authorization': `Basic ${Buffer.from('integrationuser:y5gvr*ihW)):lSML$B*FtM]lhg^yW8a9c[.[&bqV').toString('base64')}`,
    };

    axios.post(url, data, { headers })
    .then(response => {
      // console.log(response.data);
      toast.success(`ServiceNow Ticket Submitted - ${response.data.result[0].display_value}`, {
        toastId: response.data.result[0].display_value,
        theme: 'dark',
        autoClose: 5000,
      });
    })
    .catch(error => {
      console.error(error);
      toast.error(`Submission Failed`, {
        toastId: Math.random(),
        theme: 'dark',
        autoClose: 5000,
      });
    });

    handleClose()
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Create Issue</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please fill out the information about the Issue.
          </DialogContentText>
          <Box marginBottom={2}>
            <FormControl fullWidth>
              <InputLabel>Terminal Id or Subject</InputLabel>
              <Input
                autoFocus
                margin="dense"
                name="shortDescription"
                type="text"
                value={incident.shortDescription}
                onChange={handleInputChange}
              />
            </FormControl>
          </Box>
          <Box marginBottom={2}>
            <FormControl fullWidth>
              <InputLabel>Description of Issue</InputLabel>
              <Input
                autoFocus
                margin="dense"
                name="description"
                type="text"
                value={incident.description}
                onChange={handleInputChange}
              />
            </FormControl>
          </Box>
          <Box marginBottom={2}>
            <FormControl fullWidth>
              <InputLabel>Urgency</InputLabel>
              <Select
                margin="dense"
                name="urgency"
                value={incident.urgency}
                onChange={handleInputChange}
              >
                <MenuItem value={1}>1 High</MenuItem>
                <MenuItem value={2}>2 Medium</MenuItem>
                <MenuItem value={3}>3 Low</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box marginBottom={2}>
            <FormControl fullWidth>
              <InputLabel>Impact</InputLabel>
              <Select
                margin="dense"
                name="impact"
                value={incident.impact}
                onChange={handleInputChange}
              >
                <MenuItem value={1}>1 High</MenuItem>
                <MenuItem value={2}>2 Medium</MenuItem>
                <MenuItem value={3}>3 Low</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box marginBottom={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={assignToMe}
                  onChange={handleCheckboxChange}
                  name="assignToMe"
                  color="primary"
                />
              }
              label="Assign to Me"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleCreate} color="primary">
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
